import { inlineFieldValidations } from './inlineFormFieldsValidations.js';
import { patientFormTranslatedStrings } from '../../translations/PatientFormTranslations';
import { GenderType, FieldName } from '../../utils/enums';
import utils from '../../utils/utils';

const {
  firstName,
  lastName,
  middleInitial,
  gender,
  dateOfBirth,
  chartNumber,
  zipCode,
  maleOption,
  femaleOption
} = patientFormTranslatedStrings;

const inlineFormFields = [
  {
    name: FieldName.FIRST_NAME,
    inputType: 'text',
    label: firstName,
    widthColumns: 9,
    isRequired: true,
    isKeyField: true,
    isShowErrorBorder: false,
    isVisible: true,
    isDisabled: false,
    validations: inlineFieldValidations(FieldName.FIRST_NAME),
    normalize: utils.capitalizeString
  },
  {
    name: FieldName.LAST_NAME,
    inputType: 'text',
    label: lastName,
    widthColumns: 9,
    isRequired: true,
    isKeyField: true,
    isShowErrorBorder: false,
    isVisible: true,
    isDisabled: false,
    validations: inlineFieldValidations(FieldName.LAST_NAME),
    normalize: utils.capitalizeString
  },
  {
    name: FieldName.DATE_OF_BIRTH,
    inputType: 'date',
    label: dateOfBirth,
    isRequired: false,
    isKeyField: false,
    isShowErrorBorder: false,
    isVisible: true,
    isDisabled: false
  },
  {
    name: FieldName.GENDER,
    inputType: 'radio-button',
    label: gender,
    isRequired: false,
    isKeyField: false,
    isShowErrorBorder: false,
    isVisible: true,
    isDisabled: false,
    options: [
      { id: 'gender-male', labelId: 'label-gender-male', label: maleOption, value: GenderType.Male.value },
      { id: 'gender-female', labelId: 'label-gender-female', label: femaleOption, value: GenderType.Female.value }
    ],
    validations: inlineFieldValidations(FieldName.GENDER)
  },
  {
    name: FieldName.MI,
    inputType: 'text',
    label: middleInitial,
    widthColumns: 9,
    isRequired: false,
    isKeyField: false,
    isShowErrorBorder: false,
    isVisible: false,
    isDisabled: false,
    validations: inlineFieldValidations(FieldName.MI)
  },
  {
    name: FieldName.CHART_NUMBER,
    inputType: 'text',
    label: chartNumber,
    isRequired: false,
    isKeyField: true,
    isShowErrorBorder: false,
    isVisible: true,
    isDisabled: false,
    validations: inlineFieldValidations(FieldName.CHART_NUMBER),
    normalize: utils.capitalizeString
  },
  {
    name: FieldName.ZIP_CODE,
    inputType: 'text',
    label: zipCode,
    isRequired: false,
    isKeyField: false,
    isShowErrorBorder: false,
    isVisible: false,
    isDisabled: false,
    validations: inlineFieldValidations(FieldName.ZIP_CODE)
  }
];

export const getFieldValidations = validationConfig => {
  if (!validationConfig.name) {
    return [];
  }
  if (!validationConfig.isRequired) {
    return inlineFieldValidations(validationConfig.name);
  }
  return inlineFieldValidations(`${validationConfig.name}Required`);
};

export default inlineFormFields;
